import React, { useState, useEffect } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { FaTrash } from "react-icons/fa";
import LoadingSpinner from "../../LoadingSpinner";
import { fetchHistory } from "../../../features/history/historyAPI";
import { deleteHistoryAction } from "../../../features/history/historyAPI"; // Import deleteHistoryAction function
import { formatDate,getTitle } from "../../../features/history/utils/historyFunctions";

const History = () => {
  const [historyData, setHistoryData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedActionId, setSelectedActionId] = useState(null); // Track the selected action's ID
  const [selectedAction, setSelectedAction] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      fetchHistory(storedToken, setHistoryData, setLoading, setError);
    }
  }, []);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredHistory = historyData.filter((item) =>
    item.action.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Function to handle click on trash icon
  const handleTrashClick = (actionId,action) => {
    setSelectedAction(action); 
    setSelectedActionId(actionId)
    setShowConfirmation(true);
  };
  

 // Function to confirm action deletion
const confirmDelete = async () => {
  try {
    await deleteHistoryAction(selectedActionId, localStorage.getItem('token'));
    // Refetch history data after deletion
    fetchHistory(localStorage.getItem('token'), setHistoryData, setLoading, setError);
    setShowConfirmation(false);
  } catch (error) {
    console.error('Error deleting history action:', error);
  }
};


  return (
    <div className="py-2 pr-2 pl-4 w-full">
      <h2 className="sections-title text-2xl font-bold my-4 text-center">
        History
      </h2>
      <div className="flex items-center justify-center mb-4 w-full">
      <div className="flex items-end rounded-md bg-gray-100 py-1 ml-10 md:ml-0 mr-4 w-full sm:w-1/2">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="pl-4 py-3 mr-2 bg-gray-100 focus:outline-none w-full"
          />
          <AiOutlineSearch className="text-gray-500 w-11 h-10 sm:h-11 my-1 px-1 border-l border-black-300" />
        </div>
      </div>
      <ul className="divide-y divide-gray-200 p-4">
  {loading ? (
    <LoadingSpinner />
  ) : error ? (
    <li>Error: {error}</li>
  ) : filteredHistory.length === 0 ? (
    <li>No history found.</li>
  ) : (
    filteredHistory.slice(-8).map((item) => (
      <li key={item.id} className="py-3 flex justify-between items-center">
       <div className="cursor-pointer">
    {getTitle(item)} - <span className="text-gray-500 text-sm">{formatDate(item.created_at)}</span>
</div>

       
          <FaTrash className="cursor-pointer mr-4" onClick={() => handleTrashClick(item.id,getTitle(item))} />
        
       
      </li>
    ))
  )}
</ul>
 
      {/* Confirmation Popup */}
      {showConfirmation && (
  <div className="fixed top-0 left-0 w-full h-full bg-gray-500 bg-opacity-50 flex items-center justify-center">
    <div className="bg-white p-8 rounded-md">
      <p className="mb-4">Are you sure you want to discard {selectedAction}?</p>
      <div className="flex justify-center">
        <button
          className="text-gray-500 px-4 py-2 rounded-md mr-4"
          onClick={() => setShowConfirmation(false)} // Close the confirmation popup
        >
          Cancel
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded-md"
          onClick={confirmDelete} // Confirm deletion
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default History;
